var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _rect3, _rect4, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJaneGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eeb96137-3278-437b-b769-a75392203778",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95.9 47.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b0723202-1d11-4737-b631-66cefc6a3419,.eeaa465d-0e2e-48f3-8814-64dbd67e3ee7{fill:#fff;}.ae22772c-44e1-4743-a8b9-cd4517300006,.b968c662-5bee-4d07-8adb-9a1fdb2a5271,.f527860f-4a78-4402-933d-75a23f84d107{fill-rule:evenodd;}.f80c8968-7a97-44bc-8e28-bee68797a68f{fill:#0e0e0e;}.af871da0-0519-470b-ac13-f0a30b2cdc23{fill:#ffc220;}.b0723202-1d11-4737-b631-66cefc6a3419{stroke:#fff;stroke-linejoin:round;stroke-width:0.42px;}.aa20ee15-4539-4236-bd52-d15f368f9023{fill:url(#f3fa4027-0872-44b9-83f8-bde4c5f789b1);}.a7d7c921-835e-40d9-b83d-55408518fe1a{fill:none;stroke:#0e0e0e;stroke-width:1.05px;}.ae22772c-44e1-4743-a8b9-cd4517300006{fill:url(#eb0df593-f0a8-40f5-902d-4b6fc8425e95);}.b88512ce-7a4f-475d-8496-81c37a872f77{mask:url(#e0659e74-5d27-4fad-b1bb-e1030ecaa4cc);}.a1fc5d78-34d2-49e4-a3af-185fcd116b0d{fill:url(#fc0533d2-cc0b-4afb-8a9f-8d94e0f8e300);}.f527860f-4a78-4402-933d-75a23f84d107{fill:url(#a9c90096-039f-45c9-a7e5-321fb0b79e91);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3fa4027-0872-44b9-83f8-bde4c5f789b1",
    x1: 12.65,
    y1: 29.47,
    x2: 12.65,
    y2: 5.23,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ffc220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb0df593-f0a8-40f5-902d-4b6fc8425e95",
    x1: 37.41,
    y1: 29.47,
    x2: 37.41,
    y2: 5.23,
    xlinkHref: "#f3fa4027-0872-44b9-83f8-bde4c5f789b1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e0659e74-5d27-4fad-b1bb-e1030ecaa4cc",
    x: 23.29,
    y: 20.53,
    width: 28,
    height: 28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6cb99b8-b245-4f3f-9e1a-0652e4157901",
    "data-name": "path-10-outside-1 3255 50930"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "eeaa465d-0e2e-48f3-8814-64dbd67e3ee7",
    x: 23.29,
    y: 20.53,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "b968c662-5bee-4d07-8adb-9a1fdb2a5271",
    d: "M49.53,34.65A12.11,12.11,0,0,0,37.41,22.53h0A12.12,12.12,0,0,0,25.29,34.65h0A12.12,12.12,0,0,0,37.41,46.77h0A12.12,12.12,0,0,0,49.53,34.65Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc0533d2-cc0b-4afb-8a9f-8d94e0f8e300",
    x1: 61.12,
    y1: 29.47,
    x2: 61.12,
    y2: 5.23,
    xlinkHref: "#f3fa4027-0872-44b9-83f8-bde4c5f789b1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9c90096-039f-45c9-a7e5-321fb0b79e91",
    x1: 83.78,
    y1: 29.47,
    x2: 83.78,
    y2: 5.23,
    xlinkHref: "#f3fa4027-0872-44b9-83f8-bde4c5f789b1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    d: "M38.7,13.07V5.78H37.05v7.15a1.43,1.43,0,1,1-2.86.11H32.54a2.85,2.85,0,0,0,3.09,3A2.78,2.78,0,0,0,38.7,13.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    d: "M39.84,12.29A3.52,3.52,0,0,0,43.25,16a2.83,2.83,0,0,0,2.27-1.09v.95h1.56V8.75H45.52V9.7a2.83,2.83,0,0,0-2.27-1.09A3.52,3.52,0,0,0,39.84,12.29Zm5.81,0a2.12,2.12,0,1,1-4.22,0,2.12,2.12,0,1,1,4.22,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    d: "M48.76,15.83h1.56V12.35c0-1.52.79-2.33,1.83-2.33s1.47.68,1.47,1.8v4h1.56V11.57a2.67,2.67,0,0,0-2.71-3,2.42,2.42,0,0,0-2.15,1.1v-1H48.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    d: "M56.25,12.29A3.55,3.55,0,0,0,60,16a3.64,3.64,0,0,0,3.22-1.64L62,13.48a2.22,2.22,0,0,1-2,1.08,2.06,2.06,0,0,1-2.18-1.93h5.56a5,5,0,0,0,0-.51A3.28,3.28,0,0,0,60,8.61,3.59,3.59,0,0,0,56.25,12.29Zm3.64-2.37a1.86,1.86,0,0,1,1.9,1.58H57.85A2,2,0,0,1,59.89,9.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "af871da0-0519-470b-ac13-f0a30b2cdc23",
    d: "M47.91,1.06A2.53,2.53,0,0,0,45.9,0a2.44,2.44,0,0,0-2.35,2.36A4.19,4.19,0,0,0,45.3,5.51a9.75,9.75,0,0,0,2.6,1.72,9.34,9.34,0,0,0,2.61-1.72,4.2,4.2,0,0,0,1.76-3.15A2.45,2.45,0,0,0,49.91,0,2.49,2.49,0,0,0,47.91,1.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    x: 24.11,
    y: 30.42,
    width: 2.69,
    height: 4.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    x: 9.17,
    y: 35.32,
    width: 7.72,
    height: 6.37
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b0723202-1d11-4737-b631-66cefc6a3419",
    d: "M32.67,34.86a.21.21,0,0,1-.21-.21.21.21,0,0,1,.21-.21A4.53,4.53,0,0,0,37.2,29.9a.22.22,0,0,1,.21-.21.21.21,0,0,1,.21.21,4.53,4.53,0,0,0,4.53,4.54.21.21,0,0,1,.21.21.21.21,0,0,1-.21.21,4.53,4.53,0,0,0-4.53,4.53.21.21,0,0,1-.21.21.22.22,0,0,1-.21-.21A4.53,4.53,0,0,0,32.67,34.86Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    x: 24.11,
    y: 30.42,
    width: 2.69,
    height: 4.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    x: 9.17,
    y: 35.32,
    width: 7.72,
    height: 6.37
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "aa20ee15-4539-4236-bd52-d15f368f9023",
    d: "M24.24,26.22a3.69,3.69,0,0,0-3.69-3.69H13.17A12.12,12.12,0,0,0,1.05,34.65h0A12.12,12.12,0,0,0,13.17,46.77h5.27a5.8,5.8,0,0,0,5.8-5.8v-8.7A1.25,1.25,0,0,0,23,31h-8.8a3.66,3.66,0,0,0-3.65,3.66h0a3.65,3.65,0,0,0,3.65,3.65h1.09a.53.53,0,0,1,.53.53h0a.53.53,0,0,1-.53.53h-1a4.75,4.75,0,0,1-4.75-4.74h0a4.75,4.75,0,0,1,4.75-4.75h6.32a3.69,3.69,0,0,0,3.69-3.68Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a7d7c921-835e-40d9-b83d-55408518fe1a",
    d: "M20.55,22H13.17a12.65,12.65,0,0,0,0,25.29h5.27A6.33,6.33,0,0,0,24.77,41v-8.7A1.78,1.78,0,0,0,23,30.5h-8.8A4.18,4.18,0,0,0,10,34.66h0a4.22,4.22,0,0,1,4.22-4.22h6.32a4.22,4.22,0,1,0,0-8.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ae22772c-44e1-4743-a8b9-cd4517300006",
    d: "M49.53,34.65A12.11,12.11,0,0,0,37.41,22.53h0A12.12,12.12,0,0,0,25.29,34.65h0A12.12,12.12,0,0,0,37.41,46.77h0A12.12,12.12,0,0,0,49.53,34.65Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b88512ce-7a4f-475d-8496-81c37a872f77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f80c8968-7a97-44bc-8e28-bee68797a68f",
    d: "M37.41,47.82A13.17,13.17,0,0,0,50.58,34.65h-2.1A11.07,11.07,0,0,1,37.41,45.71ZM24.24,34.65A13.17,13.17,0,0,0,37.41,47.82V45.71A11.06,11.06,0,0,1,26.35,34.65ZM37.41,23.58A11.07,11.07,0,0,1,48.48,34.65h2.1A13.17,13.17,0,0,0,37.41,21.47Zm0-2.11A13.18,13.18,0,0,0,24.24,34.65h2.11A11.06,11.06,0,0,1,37.41,23.58Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b0723202-1d11-4737-b631-66cefc6a3419",
    d: "M32.67,34.86a.21.21,0,0,1-.21-.21.21.21,0,0,1,.21-.21A4.53,4.53,0,0,0,37.2,29.9a.22.22,0,0,1,.21-.21.21.21,0,0,1,.21.21,4.53,4.53,0,0,0,4.53,4.54.21.21,0,0,1,.21.21.21.21,0,0,1-.21.21,4.53,4.53,0,0,0-4.53,4.53.21.21,0,0,1-.21.21.22.22,0,0,1-.21-.21A4.53,4.53,0,0,0,32.67,34.86Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a1fc5d78-34d2-49e4-a3af-185fcd116b0d",
    d: "M61.12,27.8a5.27,5.27,0,0,0-5.27-5.27h0a5.27,5.27,0,0,0-5.27,5.27V41a5.76,5.76,0,0,0,5.75,5.75H66.39a5.27,5.27,0,0,0,5.27-5.27h0a5.27,5.27,0,0,0-5.27-5.27H61.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a7d7c921-835e-40d9-b83d-55408518fe1a",
    d: "M66.39,35.7H61.65V27.8a5.8,5.8,0,1,0-11.59,0V41a6.27,6.27,0,0,0,6.27,6.27H66.39a5.8,5.8,0,1,0,0-11.59Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "f527860f-4a78-4402-933d-75a23f84d107",
    d: "M94.85,34.65A12.12,12.12,0,0,0,82.73,22.53H74.82a2.1,2.1,0,0,0-2.1,2.1v20a2.11,2.11,0,0,0,2.1,2.11h7.91A12.12,12.12,0,0,0,94.85,34.65ZM82.73,39.39a.52.52,0,0,0,.52-.53V30.43a.52.52,0,0,0-.52-.53h0a.53.53,0,0,0-.53.53v8.43a.53.53,0,0,0,.53.53Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a7d7c921-835e-40d9-b83d-55408518fe1a",
    d: "M82.73,22H74.82a2.63,2.63,0,0,0-2.63,2.63v20a2.63,2.63,0,0,0,2.63,2.63h7.91a12.65,12.65,0,0,0,0-25.29Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b0723202-1d11-4737-b631-66cefc6a3419",
    d: "M32.67,34.86a.21.21,0,0,1-.21-.21.21.21,0,0,1,.21-.21A4.53,4.53,0,0,0,37.2,29.9a.22.22,0,0,1,.21-.21.21.21,0,0,1,.21.21,4.53,4.53,0,0,0,4.53,4.54.21.21,0,0,1,.21.21.21.21,0,0,1-.21.21,4.53,4.53,0,0,0-4.53,4.53.21.21,0,0,1-.21.21.22.22,0,0,1-.21-.21A4.53,4.53,0,0,0,32.67,34.86Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaneGold);
export default __webpack_public_path__ + "static/media/jane-gold.c4d94606d53cb976b7324c3c2e152fdc.svg";
export { ForwardRef as ReactComponent };